// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-error-dialog {
  display: grid;
  gap: 0.75rem;
  color: #1f2937;
}

.action-error-dialog__summary {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #b42318;
}

.action-error-dialog__message {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.55;
}

.action-error-dialog__details {
  margin: 0;
  padding-left: 1.1rem;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #4b5563;
}`, "",{"version":3,"sources":["webpack://./src/modules/app-common/components/action-error-dialog/action-error-dialog.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,YAAA;EACA,cAAA;AACJ;;AAEA;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AAEA;EACI,SAAA;EACA,kBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,SAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AACJ","sourcesContent":[".action-error-dialog {\n    display: grid;\n    gap: 0.75rem;\n    color: #1f2937;\n}\n\n.action-error-dialog__summary {\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 700;\n    color: #b42318;\n}\n\n.action-error-dialog__message {\n    margin: 0;\n    font-size: 0.95rem;\n    line-height: 1.55;\n}\n\n.action-error-dialog__details {\n    margin: 0;\n    padding-left: 1.1rem;\n    font-size: 0.9rem;\n    line-height: 1.5;\n    color: #4b5563;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
